<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'report-rota') {
            next({ name: 'promotor-contrato-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'report-rota') {
            this.$router.push({ name: 'promotor-contrato-list' });
        }
    },
};
</script>
